// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"115":"7ece9241","157":"8dc077ea","446":"69dc3b30","483":"be1a7b7e","518":"76108619","599":"622efd19","652":"fe3e950d","665":"c9ed6e04","721":"af240349","996":"dada526b"}[chunkId] + ".chunk.js";
};